// extracted by mini-css-extract-plugin
export default {"modal":"ModalGuidedDealIntake_modal__4L7Gw","body":"ModalGuidedDealIntake_body__K9-5E"};